import { useCallback, useRef, useState, useMemo } from 'react';
import '../Analitos.scss';
import { useApiConfiguration } from '../../../api/api.configuration';
import { Button, ScrollView, Tooltip } from 'devextreme-react';
import Toolbar, { Item as ToolbItem } from 'devextreme-react/toolbar';
import { formatMessage } from 'devextreme/localization';
import { Form, Item, Label } from 'devextreme-react/form';
import TagBox from 'devextreme-react/tag-box';

export const ReferencesText = ({ IdAnalito, ValRefText }: { IdAnalito: number; ValRefText: any }) => {
  const { UpdateValRefTextAsync } = useApiConfiguration();
  const formRef = useRef<Form>(null);
  const [EditItem, setEditItem] = useState<boolean>(true);

  // Convertir el string separado por comas a array para el TagBox
  const valoresPermitidos = useMemo<string[]>(() => {
    const raw = ValRefText?.An_ValRefTextPermitidos || '';
    if (!raw || !raw.trim()) return [];
    return raw.split(',').map((v: string) => v.trim()).filter((v: string) => v.length > 0);
  }, [ValRefText?.An_ValRefTextPermitidos]);

  // Usar ref para rastrear valores sin causar re-renders
  const tagValuesRef = useRef<string[]>(valoresPermitidos);
  const [tagCount, setTagCount] = useState<number>(valoresPermitidos.length);
  const [tagDisplay, setTagDisplay] = useState<string>(valoresPermitidos.join(', '));

  const handleEditClick = useCallback(() => {
    setEditItem(false);
    formRef.current?.forceUpdate();
  }, [IdAnalito]);

  const handleSaveClick = useCallback(() => {
    // Sincronizar los tags al ValRefText antes de guardar
    ValRefText.An_ValRefTextPermitidos = tagValuesRef.current.join(',');
    UpdateValRefTextAsync(IdAnalito, ValRefText)
      .then((res) => {
        if (res === 107) {
          setEditItem(true);
        }
      })
      .catch(() => {
        throw new Error('Error actualizando el texto de referencia');
      });
  }, [IdAnalito, ValRefText]);

  function screenByWidth(width) {
    return width < 720 ? 'sm' : 'md';
  }

  return (
    <div>
      <ScrollView className='view-wrapper-scroll' width={'100%'}>
        <Toolbar className='toolbar-common'>
          <ToolbItem location='after' locateInMenu='auto' widget='dxButton' showText='inMenu'>
            <Button id='toolBarEdit' text={formatMessage('toolBarEdit')} stylingMode='outlined' icon='edit' type='default' onClick={handleEditClick} />
          </ToolbItem>
          <ToolbItem location='after' locateInMenu='auto' widget='dxButton' showText='inMenu'>
            <Button id='toolBarSave' text={formatMessage('toolBarSave')} stylingMode='outlined' icon='save' type='default' onClick={handleSaveClick} />
          </ToolbItem>
        </Toolbar>
        <div className='formStyle'>
          <form>
            <Form formData={ValRefText} ref={formRef} labelLocation='top' minColWidth={233} colCount='auto' screenByWidth={screenByWidth} colCountByScreen={{ sm: 1, md: 2 }}>
              <Item key={`${IdAnalito}_valref`} editorType='dxTextBox' dataField='An_ValRefText' disabled={EditItem}>
                <Label>TEXTO DE REFERENCIA</Label>
              </Item>
              <Item key={`${IdAnalito}_valcritico`} editorType='dxTextBox' dataField='An_ValCritico' disabled={EditItem}>
                <Label>TEXTO CRÍTICO</Label>
              </Item>
            </Form>
          </form>

          {/* Valores no permitidos - TagBox estilo badges (no controlado para evitar loop de DevExtreme) */}
          <div style={{ marginTop: '16px', padding: '0 4px' }}>
              <div style={{ fontSize: '13px', fontWeight: '600', color: '#d32f2f', marginBottom: '6px' }}>
                VALORES NO PERMITIDOS
              </div>
              <div style={{ fontSize: '12px', color: '#888', marginBottom: '8px' }}>
                Escriba un valor y presione <strong>Enter</strong> para agregarlo. Los resultados que coincidan con estos valores se marcarán como alterados.
              </div>
              <TagBox
                defaultValue={valoresPermitidos}
                onValueChanged={(e: any) => {
                  const newValues: string[] = (e.value || []).map((v: string) => v.trim()).filter((v: string) => v.length > 0);
                  tagValuesRef.current = newValues;
                  setTagCount(newValues.length);
                  setTagDisplay(newValues.join(', '));
                }}
                acceptCustomValue={true}
                placeholder={EditItem ? '' : 'Escriba un valor y presione Enter...'}
                disabled={EditItem}
                searchEnabled={false}
                showSelectionControls={false}
                multiline={true}
                stylingMode='outlined'
                width='100%'
                onCustomItemCreating={(e: any) => {
                  const newValue = (e.text || '').trim();
                  if (newValue) {
                    e.customItem = newValue;
                  } else {
                    e.customItem = null;
                  }
                }}
              />
              {tagCount > 0 && (
                <div style={{ fontSize: '11px', color: '#666', marginTop: '6px', fontStyle: 'italic' }}>
                  {tagCount} {tagCount === 1 ? 'valor no permitido' : 'valores no permitidos'} configurados
                  <span style={{ color: '#999', marginLeft: '8px' }}>
                    (Almacenado: {tagDisplay})
                  </span>
                </div>
              )}
            </div>
        </div>
      </ScrollView>
      <Tooltip showEvent='mouseenter' hideEvent='mouseleave' position={'top'} target={'#toolBarSave'}>
        {formatMessage('toolBarSave')}
      </Tooltip>
      <Tooltip showEvent='mouseenter' hideEvent='mouseleave' position={'top'} target={'#toolBarEdit'}>
        {formatMessage('toolBarEdit')}
      </Tooltip>
    </div>
  );
};
